var riot = require("riot");

riot.tag2('ahv-map-display', '<div class="ahv-display"> <div class="ahv-display-header" id="ahv-map-display-header">&nbsp;</div> <div id="map-container"></div> <div class="ahv-display-footer">&nbsp;</div> </div>', '', '', function(opts) {
    require("./MapDisplayController").init(this, L);
});



/*****************
 ** WEBPACK FOOTER
 ** ./src/components/mapDisplay/ahv-map-display.tag
 ** module id = 81
 ** module chunks = 0
 **/